module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.idAttr
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('_input', {
    attrs: {
      "type": _vm.checkbox,
      "idAttr": _vm.idAttr,
      "value": _vm.value,
      "setting": _vm.setting
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9917a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Field/Checkbox.vue
// module id = 230
// module chunks = 1